import { useState } from "react";
import { Button, Flex } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const ColumnSearchFields = ({
  columns,
  updateFilter,
  clearFilters,
  isTableSearchFiltersEnabled
}) => {
  const [searchFields, setSearchFields] = useState({});

  const handleChange = (key, value) => {
    setSearchFields((prev) => ({
      ...prev,
      [key]: value
    }));
  };

  const handleSearch = () => {
    updateFilter(searchFields);
  };

  const handleClearFilters = () => {
    setSearchFields({});
    clearFilters();
  };

  return (
    <Flex
      gap={25}
      align="center"
      style={{ width: "100%", margin: "5px 0px" }}
    >
      {columns.map(
        ({ key, label, enableSearch }) =>
          enableSearch && (
            <div key={key} className="floating-input">
              <input
                type="text"
                value={searchFields[key] || ""}
                onChange={(e) => handleChange(key, e.target.value)}
                className="input-field"
              />
              <label
                className={
                  searchFields[key] ? "input-label filled" : "input-label"
                }
              >
                {label}
              </label>
            </div>
          )
      )}
      <Flex gap={5}>
        <Button
          type="primary"
          style={{
            padding: "12px",
            borderRadius: "20px"
          }}
          icon={<SearchOutlined />}
          onClick={handleSearch}
          disabled={
            !Object.values(searchFields).some(
              (value) => value !== undefined && value !== null && value !== ""
            )
          }
        >
          Search
        </Button>
        {isTableSearchFiltersEnabled && (
          <Button
            color="danger"
            variant="outlined"
            style={{
              padding: "12px",
              borderRadius: "20px"
            }}
            onClick={handleClearFilters}
          >
            Clear Filters
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

export default ColumnSearchFields;
